<template>
  <div :class="classes" class="asd20-tag" :style="styles">
    {{ label }}
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Asd20Tag',
  model: {
    prop: 'label',
  },
  props: {
    label: { type: String, default: '' },
    background: { type: String, default: '' },
    foreground: { type: String, default: '' },
    bordered: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return {
        'asd20-tag--bordered': this.bordered,
        'asd20-tag--transparent': this.transparent,
      }
    },
    styles() {
      return {
        '--background': this.background,
        '--foreground': this.foreground,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

.asd20-tag {
  display: flex;
  justify-content: center;
  background: var(--background-color);
  color: var(--foreground, currentColor);
  min-width: space(0.75);
  min-height: space(0.75);
  width: min-content;
  padding: space(0.0625) space(0.25);
  align-items: center;
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1;
  overflow: hidden;
  border-radius: space(0.5) 0 0 space(0.5);
  white-space: nowrap;

  &::before {
    content: '';
    width: space(0.25);
    height: space(0.25);
    margin-right: space(0.25);
    background: var(--foreground, var(--color__accent));
    border-radius: 50%;
    opacity: 1;
    box-shadow: 0px 0px 3px var(--background, currentColor);
  }

  &--bordered {
    box-shadow: 0 0 0 1px var(--background, currentColor) inset;
  }
  &--transparent {
    background: transparent;
  }
}
</style>
